module.exports = __webpack_public_path__ + "static/media/web_shopping.93e94bd3.png";